export default __webpack_public_path__ + "static/media/15_Il.7e23eba4.mp3";